var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-apex-charts',{attrs:{"type":"area","height":"112px","options":_vm.PageViewChart.viewChart.chartOptions,"series":_vm.PageViewChart.viewChart.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }